import { render, staticRenderFns } from "./list.vue?vue&type=template&id=543e25bd&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=543e25bd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543e25bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543e25bd')) {
      api.createRecord('543e25bd', component.options)
    } else {
      api.reload('543e25bd', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=543e25bd&scoped=true", function () {
      api.rerender('543e25bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/example/list.vue"
export default component.exports